import React, { useState, useEffect, useRef } from 'react';
import Header from './Header';
import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

export default function HeroHome({ images }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isHeaderHovered, setIsHeaderHovered] = useState(false);

    const menuRef = useRef(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        }
    }, []);

    const handleOutsideClick = (e) => {
        if (menuRef.current && !menuRef.current.contains(e.target) && !buttonRef.current.contains(e.target)) {
            setIsMenuOpen(false);
        }
    }

    return (
        <div className="h-screen overflow-hidden relative">

            {/* Slideshow */}
            <Fade images={images.map(img => img.path)} duration={3000} infinite={true} indicators={true} arrows={false}>
                {images.map((img, index) =>
                    <div key={index} className="h-screen bg-center bg-cover relative" style={{ backgroundImage: `url(/images/${img.path})` }}>
                        <span className="md:text-2xl absolute bottom-6 right-8 md:right-32 text-white px-2 py-1 rounded">
                            {img.name}
                        </span>
                    </div>
                )}
            </Fade>


            {/* Hero Content 
            <div className="flex flex-col h-[60%] justify-center items-center absolute inset-0 z-10">
                <div className="flex flex-col justify-center items-center border-b-2 border-black text-center py-2">
                    <h1 style={{ letterSpacing: '5px', color: '#333' }} className="text-3xl font-bold mx-[-50px] md:mx-[-150px]">
                        Crafting Visions <br className='md:hidden' /> into Reality
                    </h1>
                </div>
            </div>
            */}


            <Header />

        </div>
    );
}
